import { CSSProperties, FC } from "react";
import { ReactComponent as LogoShort } from "./logo-short.svg";
import { ReactComponent as LogoWide } from "./logo-wide.svg";
import { Flex, Typography } from "antd";

type StyleItems = 'container' | 'text' | 'image'
type StylesType = Record<StyleItems, CSSProperties>

interface Props {
  showText?: boolean
  styles?: Partial<StylesType>
}

const Logo: FC<Props> = ({ showText = true, styles }) => {

  const style: StylesType = {
    container: {
      ...styles?.container
    },
    text: {
      color: '#2A4BC2',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '24px',
      ...styles?.text
    },
    image: {
      height: 32,
      width: showText ? 180 : 100,
      cursor: "pointer",
      ...styles?.image
    },
  }

  return (
    <Flex
      gap={16}
      align={'center'}
      className={'logo-container'}
      style={style.container}
    >
      {showText
        ? <LogoWide
            style={style.image}
            className={'logo-image'}
            onClick={() => window.location.assign("/")}
          />
        : <LogoShort
            style={style.image}
            className={'logo-image'}
            onClick={() => window.location.assign("/")}
          />
      }
  </Flex>

  );
};

export { Logo };
